import React from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import * as appRoutes from "./routeConstants/appRoutes";
import AuthWrapper from "../views/Auth/AuthWrapper";
import requiredAuth from "../shared/components/HOC/requireAuth";
import Navbar from "../shared/components/Navbar";
import CourseStructureWrapper from "../views/CourseStructure/CourseStructureWrapper";
import ContentLibrary from "../views/ContentLibrary";
import Tutors from "../views/Tutors";
import Exams from "../views/Exams/Exams";
import LiveClasses from "../views/LiveClasses";
import Students from "../views/Students";
import InternalUsers from "../views/InternalUsers";
import Dashboard from "../views/Dashboard";
import TutorDetails from "../views/Tutors/TutorDetails";
import Blacklist from "../views/Students/Blacklist";
import StudentDetails from "../views/Students/StudentDetails";
import ExamRouter from "../views/Exams/examsRouter";
import Analytics from "../views/Analytics";
import StudentAnalytics from "../views/Students/Analytics";
import ListAnalyticsChapterCards from "../views/Students/Analytics/ListAnalyticsChapterCards";
import ListAnalyticsExerciseCards from "../views/Students/Analytics/ListAnalyticsExerciseCards";
import ChangePassword from "../shared/components/Navbar/ChangePassword";
import { Institute } from "../views/Institute";
import { InstituteDetails } from "../views/Institute/InstituteDetails";
import { InstituteStudentDetails } from "../views/Institute/InstituteDetails/InstituteStudents/InstituteStudentDetails";
import ListChapterAnalytics from "../views/Institute/InstituteDetails/InstituteStudents/InstituteStudentDetails/Analytics/ListChaptersAnalytics";
import Generator from "../views/Generator";
import AuthContainer from "../store/container/AuthContainer";
import Leaderboard from "../views/Leaderboard";
import Reports from "../views/Reports"
import ProductsLibrary from "../views/Products";
import InstituteTeacherDetails from "../views/Institute/InstituteDetails/InstituteTeachers/InstituteTeacherDetails";

export const appHistory = createBrowserHistory();

const AppRoutes = (props: any) => {
  const isAuthenticated = (component: any) => {
    return requiredAuth(component);
  };

  const routes = [
    { exact: false, path: appRoutes.AUTH, component: AuthWrapper },
    {
      exact: false,
      path: appRoutes.COURSE_STRUCTURE,
      component: isAuthenticated(CourseStructureWrapper),
    },
    {
      exact: false,
      path: appRoutes.CONTENT_LIBRARY,
      component: isAuthenticated(ContentLibrary),
    },
    { exact: true, path: appRoutes.TUTORS, component: isAuthenticated(Tutors) },
    {
      exact: true,
      path: appRoutes.TUTOR_DETAILS,
      component: isAuthenticated(TutorDetails),
    },
    {
      exact: false,
      path: appRoutes.EXAMS,
      component: isAuthenticated(ExamRouter),
    },
    {
      exact: false,
      path: appRoutes.LIVE_CLASSES,
      component: isAuthenticated(LiveClasses),
    },
    {
      exact: true,
      path: appRoutes.STUDENTS,
      component: isAuthenticated(Students),
    },
    {
      exact: true,
      path: appRoutes.STUDENTS_BLACKLIST,
      component: isAuthenticated(Blacklist),
    },
    {
      exact: true,
      path: appRoutes.STUDENT_DETAILS,
      component: isAuthenticated(StudentDetails),
    },
    {
      exact: true,
      path: appRoutes.STUDENT_ANALYTICS,
      component: isAuthenticated(StudentAnalytics),
    },
    {
      exact: true,
      path: appRoutes.STUDENT_ANALYTICS_CHAPTERS_LIST,
      component: isAuthenticated(ListAnalyticsChapterCards),
    },
    {
      exact: true,
      path: appRoutes.STUDENT_ANALYTICS_EXERCISES_LIST,
      component: isAuthenticated(ListAnalyticsExerciseCards),
    },
    {
      exact: false,
      path: appRoutes.INTERNAL_USERS,
      component: isAuthenticated(InternalUsers),
    },
    {
      exact: true,
      path: appRoutes.DASHBOARD,
      component: isAuthenticated(Dashboard),
    },
    {
      exact: true,
      path: appRoutes.LEADERBOARD,
      component: isAuthenticated(Leaderboard),
    },
    {
      exact: false,
      path: appRoutes.ANALYTICS,
      component: isAuthenticated(Analytics),
    },
    {
      exact: false,
      path: appRoutes.CHANGE_PASSWORD,
      component: isAuthenticated(ChangePassword),
    },
    {
      exact: true,
      path: appRoutes.INSTITUTE,
      component: isAuthenticated(Institute),
    },
    {
      exact: true,
      path: appRoutes.INSTITUTE_VIEW,
      component: isAuthenticated(InstituteDetails),
    },
    {
      exact: true,
      path: appRoutes.INSTITUTE_STUDENT_VIEW,
      component: isAuthenticated(InstituteStudentDetails),
    },
    {
      exact: true,
      path: appRoutes.INSTITUTE_TEACHER_VIEW,
      component: isAuthenticated(InstituteTeacherDetails),
    },
    {
      exact: true,
      path: appRoutes.LIST_ANALYTICS_CHAPTERS,
      component: isAuthenticated(ListChapterAnalytics),
    },
    {
      exact: true,
      path: appRoutes.GENERATOR,
      component: isAuthenticated(Generator),
    },
    {
      exact: true,
      path: appRoutes.REPORTS,
      component: isAuthenticated(Reports),
    },
    {
      exact: true,
      path: appRoutes.PRODUCTS,
      component: isAuthenticated(ProductsLibrary),
    },
  ];

  return (
    <div>
      <Router history={appHistory}>
        <Navbar />
        <Switch>
          {routes.map((route, index) => {
            return <Route key={index} {...route} component={route.component} />;
          })}
          <Route
            path="*"
            render={() => (
              <Redirect
                to={
                  props?.authenticated ? appRoutes.DASHBOARD : appRoutes.LOGIN
                }
              />
            )}
          />
        </Switch>
      </Router>
    </div>
  );
};

export default AuthContainer(AppRoutes);
